// extracted by mini-css-extract-plugin
export default {"profileDetails":"profile_profileDetails__AUyuz"};